module.exports = __webpack_public_path__ + "static/1.2.B.1 CASA MERCEA RANDARE 1-103d6a9a084ea6f37af9d77ae2b17d05.jpg";